import axios from 'axios';
import store from "@/store";
import { changeChatWindowStatus, hideLoadingScreen } from '../utils';
import { EventBus } from "@/event-bus";

const qs = require('querystring-es3');

// Consecutive "no operators" polls (1/s) tolerated before giving up:
// presence flaps for a few seconds and must not bounce waiting clients.
const NO_OPERATORS_POLLS_BEFORE_CLOSE = 5;

class ChatService {
    popupWindow = null

    constructor(store/*, webRTC*/) {
        this.baseUrl = process.env.VUE_APP_PWS_BASE_URL;
        this.store = store;
        this.conn = null;
        this.isRefreshing = false;
        this.languageEquivalences = {
            'en': 'en',
            'es': 'sp'
        };
        this.threadRefreshCallback = null;
        this.intervalCheckPosition = null;
        this.noOperatorsStreak = 0;
        this.operatorsRefreshCallback = null;
        //this.webRTC = webRTC;
    }

    getThreadData(action) {
        const { id, token, lastId, language, agentTyping } = this.store.state;
        const data = {
            thread: id,
            token: token,
            lastid: lastId,
            locale: language,
            user: true,
            agentTyping: agentTyping,
        };
        if (action) {
            data.act = action;
        }
        return data;
    }

    async refreshThread() {
        const { id, token } = this.store.state;
        if (id && token) {
            if (!this.isRefreshing) {
                this.isRefreshing = Date.now();
                try {
                    await this.sendRequest('refresh');
                } catch (error) {
                    console.error('Error refreshing thread:', error.message, error.stack);
                } finally {
                    if(this.store.state.chatWindowStatus === 3 && this.conn.readyState === WebSocket.OPEN){
                        this.stopThreadRefresh()
                    }else {
                        this.isRefreshing = false;
                    }
                }
            } else {
                // @TODO: Handle poor internet connection (difference between current and last call)
            }
        }
    }

    async deleteMessage(messageId) {
            const data = this.getThreadData('hidemsg');
            data.messageid = messageId;
            data.visible = 0;
            return axios.post(
                // this.baseUrl + 'thread.php?content_type=json&act=hidemsg',
                this.baseUrl + 'thread.php',
                qs.stringify(data)
            ).then((response) => {
                let respData = response.data;
                this.serverResponse(respData);
                this.sendRequest('refresh');
            }).finally(() => {
                this.isRefreshing = false;
            });
    }

    async isAgentTyping() {
        return axios.get(
            this.baseUrl + 'chat.php/print_thread_messages'
        )
        .then((response) => {
            this.store.commit('setAgentTyping', response.data.agentTyping);
        }
        ).catch((error) => {
            console.error('Error getting agent typing status:', error.message, error.stack);
        }
        );
    }

    // async deleteMessage(messageId) {
    //     const confirmation = window.confirm('Estas seguro que quieres eliminar el mensaje');
    //     if (confirmation) {
    //         const container = document.getElementById("mid_" + messageId);
    //         const msgdlt = document.getElementById("msgdlt_" + messageId);
    //         jQuery(container).find('.hidemsg').remove();
    //         jQuery(container).find('.messagetodelete').css('text-decoration', 'line-through');
    //         msgdlt.innerHTML = "<span> - Mensaje eliminado</span>";

    //         const data = this.getThreadData('hidemsg');
    //         data.messageid = messageId;
    //         data.visible = 0;

    //         return axios.post(
    //             this.baseUrl + 'thread.php?content_type=json&t=hidemsg',
    //             qs.stringify(data)
    //         ).then((response) => {
    //             let respData = response.data;
    //             this.serverResponse(respData);
    //         }).finally(() => {
    //             this.isRefreshing = false;
    //         });
    //     }
    // }




    postMessage(message) {
        this.isRefreshing = Date.now();
        this.sendRequest('post', message);
    }

    sendAnswer(data, peerConnection) {
        if (this.conn) {
            this.conn.send(JSON.stringify({ data, peerConnection }));
        }
    }

    async sendRequest(action, content) {
        const data = this.getThreadData(action);

        if (content) {
            switch (action) {
                case "post":
                    data.message = content;
                    break;
                case "shareUrl":
                    data.url = content;
                    break;
                default:
                    console.warn(`Unknown action: ${action}`);
            }
        }

        if (this.conn && this.conn.readyState === WebSocket.OPEN) {
            this.conn.send(JSON.stringify({ action, data }));
        } else {
            try {
                const response = await axios.post(
                    `${this.baseUrl}thread.php?content_type=json&t=${action}`,
                    qs.stringify(data)
                );
                const respData = response.data;
                this.serverResponse(respData);
            } catch (error) {
                console.error('Error sending request:', error.message, error.stack);
            }
        }
    }

    // serverResponse(respData) {
    //     if (respData.success) {
    //         this.store.commit('updateThread', respData.thread);
    //     } else {
    //         console.error('Server error:', respData.error);
    //     }
    // }

    sendFiles(files) {
        const formData = new FormData();
        files.forEach((file, i) => {
            formData.append('files[' + i + ']', file);
        });

        formData.append('act', 'files');
        formData.append('thread', this.store.state.id,);
        formData.append('token', this.store.state.token,);
        formData.append('lastid', this.store.state.lastId,);
        formData.append('user', true);


        // var data = this.getThreadData(action);
        return axios.post(
            this.baseUrl + 'thread.php?content_type=json&t=' + formData.get('act'),
            formData, {
            headers:
                { 'Content-Type': 'multipart/form-data' }
        }
        ).then((response) => {
            let respData = response.data;
            this.serverResponse(respData);
            this.sendRequest('refresh');
        }).finally(() => {
            this.isRefreshing = false;
        });
    }

    checkSocketConnection() {
        if (!this.conn || this.conn.readyState === WebSocket.CLOSED || this.conn.readyState === WebSocket.CLOSING) {
            if (this.conn) {
                this.conn.close();
            }
            this.conn = null;
            this.getSocket();
        }
    }


    async getSocket() {
        if (!this.conn && window["WebSocket"] && process.env.VUE_APP_PWS_SOCKET_URL) {
            this.conn = new WebSocket(process.env.VUE_APP_PWS_SOCKET_URL);
            this.conn.onopen = () => {
                this.store.commit("setWsState", true);
            };
            this.conn.onclose = () => {
                this.store.commit("setWsState", false);
                this.conn = null;
                this.isRefreshing = false;
                if (this.store.state.id && this.store.state.token) {
                    setTimeout(() => {
                        this.checkSocketConnection();
                    }, 600000);
                    this.startThreadRefresh()
                }
            };
            this.conn.onmessage = async (evt) => {


                var data = evt.data;
                if (data != 'wrong thread') {
                    try {
                        data = JSON.parse(data);
                    } catch (e) {
                        // thread.php can answer with an empty or non-JSON body. Drop that
                        // frame instead of rejecting the handler: the socket stays open and
                        // the next message is processed normally.
                        console.warn('[chat] discarded non-JSON socket payload:', evt.data);
                        return;
                    }
                }

                this.store.commit("setBanned", {
                    banned: data.isBanned,
                    till: data.till ? new Date(data.till).toISOString().split('T')[0] : null
                });

                if (data.socket_action) {
                    switch (data.socket_action) {
                        case "trigger_refresh":
                            this.sendRequest('refresh');
                            return;
                    }
                }/*else if(data.data && data.peerConnection.type != 'calling'){
                    await this.webRTC.initializePeerConnection(data)
                }*/
                this.serverResponse(data);
            };
        } else {
            console.error("******************");
            console.error("Your browser does not support WebSockets.");
            console.error("******************");
        }
        return this.conn;
    }

    getWebSocket(){
        if(!this.conn){
            // initialize the socket if it hasn't been initialized
            this.getSocket();
        }
        return this.conn;
    }

    async sendShareNotify(active) {
        this.conn.send(JSON.stringify({
            "data": {
                thread: this.store.state.id,
                token: this.store.state.token,
                'act': "calling"
            },
            'peerConnection':
            {
                // this.peerConnection.localDescription
                'type': 'screenSharing',
                'active': active
            }
        }));
    }

    serverResponse(respData){
        if(respData.success === false && respData.error === 'wrongCharacters'){
            if (window.chatFooter) {
                window.chatFooter.showWrongCharacters();
            }
        }

        if (respData == 'wrong thread'){
            respData = {thread_state: "closed"};
        }

        if (respData.refresh) {
            this.store.commit("cleanMessages");
        }

        if (respData.lastid) {
            this.store.commit("setLastId", respData.lastid);
        }
        if (respData.messages) {
            this.store.commit("addMessages", respData.messages);
        }
        if (respData.agent) {
            this.store.commit("setAgent", respData.agent);
            this.store.commit('setOperatorGotCameraActive', respData.agent.camera)
        }

        switch (respData.thread_state) {
            case "closed":

                // check if the call has been initialized
                /*if(this.store.getters.isCallActive){
                    this.webRTC.hangout();
                }*/

                if(this.store.state.closeChatTime === null){
                    this.store.commit('setCloseChatTime', Date.now());
                }
                this.stopThreadRefresh();
                // A thread closed while still queued (operator, cron, expired after a reload)
                // has nothing to show: go back to the menu instead of waiting forever.
                if (this.store.getters.chatWindowStatusType === 'queue') {
                    this.stopQueueRefresh();
                    this.setThreadClosed();
                    this.store.commit('changeChatWindowStatus', 1);
                }
                break;
            case "queue":
                if (this.store.getters.chatWindowStatusType !== 'waiting') {
                    this.store.commit('changeChatWindowStatus', 6);
                }
                this.store.commit('changeWaitingList', respData.queue);
                break;
            default:
                if (this.store.getters.chatWindowStatusType !== 'active') {
                    this.store.commit('changeChatWindowStatus', 3);
                    hideLoadingScreen();
                    this.getInitialMessage();
                }
                break;
        }

        if(respData.thread_state) this.store.commit('setThreadState', respData.thread_state);

        this.store.commit('setActiveVideocall', respData.videocall );

        this.store.commit('setCloseByInactivity', respData.closeByInactivity );

        this.store.commit('setAgentTyping', respData.isAgentTyping);
    }

    getInitialMessage() {
        this.sendRequest('salute');
    }

    async createThread(group_id, group_index) {
        // Repeated taps while the request is in flight would create one thread each.
        if (this.creatingThread) return;
        this.creatingThread = true;

        const data = {
            name: this.store.state.user.name,
            email: this.store.state.user.email,
            locale: this.store.state.language,
            info: null,
            referrer: window.location.href,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            survey: 'On',
            message: '',
            content_type: 'json',
            group: group_id
        };

        this.store.commit("setLoading", true);
        this.store.commit("setGroupId", group_id);

        try {
            const response = await axios.post(
                `${this.baseUrl}client.php`,
                qs.stringify(data)
            );

            const threadInfo = response.data;


            if (threadInfo.thread && threadInfo.token) {
                this.store.commit('cleanMessages');
                this.store.commit('setId', threadInfo.thread);
                this.store.commit('setToken', threadInfo.token);
                this.store.commit('setChatType', group_index);
                this.store.commit('setConfig', threadInfo.chatConfig);
                this.store.commit('changeChatWindowStatus', 2);
                this.store.commit("setDefaultResponses", threadInfo.default_responses);
                this.startThreadRefresh();
                this.store.commit('changeChatWindowStatus', 6);
            } else {
                switch (threadInfo.error) {
                    case "inactive_operators":
                        this.store.commit('changeChatWindowStatus', 4);
                        break;
                    default:
                        console.error('Unknown error:', threadInfo.error);
                        this.prevent_ip_banned(threadInfo)
                        break;
                }
            }
        } catch (error) {
            // 403 → origin blocked; any other error is unexpected.
            this.handleIPError(error)
        } finally {
            this.creatingThread = false;
            this.store.commit("setLoading", false);
        }
    }

    /**
     * Handles IP/origin blocking errors returned by the backend.
     *
     * On a 403 response, extracts the error message from the response body
     * and stores it in the Vuex state to display the access-blocked banner.
     * All other errors are logged to the console.
     *
     * @param {Error} error - Axios error object from a failed HTTP request
     * @returns {void}
     */
    handleIPError(error){
        if (error.response && error.response.status === 403) {
            const msg = error.response.data?.message || 'Access denied';
            this.store.commit('setAccessBlockedMessage', msg);
        } else {
            console.error('Error creating thread:', error);
        }
    }

    async setInCall(callValue, op_finish) {
        const formData = new FormData();
        formData.append('act', 'set_in_call');
        formData.append('user', 'true');
        formData.append('thread',this.store.state.id,);
        formData.append('token',this.store.state.token,);
        formData.append('call', callValue);
        formData.append('op_finish', op_finish)

        try {
            return await axios.post(
                `${this.baseUrl}thread.php?content_type=json&t=${formData.get('act')}`,
                formData);
        } catch (error) {
            console.error('Error creating thread:', error);
        }
    }

    createThreadWithOperatorId = async (group_index, group_id, operatorId) => {
        if (this.creatingThread) return;
        this.creatingThread = true;

        const data = {
            name: this.store.state.user.name,
            email: this.store.state.user.email,
            locale: this.store.state.language,
            info: null,
            referrer: window.location.href,
            survey: 'On',
            message: '',
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            content_type: 'json',
            group: group_id,
            operatorid: operatorId
        };

        try {
            const response = await axios.post(`${this.baseUrl}client.php`, qs.stringify(data));
            const threadInfo = response.data;

            if (threadInfo.thread && threadInfo.token) {
                this.store.commit('cleanMessages');
                this.store.commit('setId', threadInfo.thread);
                this.store.commit('setToken', threadInfo.token);
                this.store.commit('setConfig', threadInfo.chatConfig);
                this.store.commit('setChatType', group_index);
                this.startThreadRefresh();
            } else {
                if (threadInfo.error === "inactive_operators") {
                    this.store.commit('changeChatWindowStatus', 4);
                } else {
                    console.error('Unknown error:', threadInfo.error);
                    this.prevent_ip_banned(threadInfo)
                }
            }
        } catch (error) {
            // 403 → origin blocked; any other error is unexpected.
            this.handleIPError(error)
        } finally {
            this.creatingThread = false;
            // SelectOperator turns the loading on before calling; without this an
            // "inactive_operators" answer left the overlay blocking the widget.
            this.store.commit("setLoading", false);
        }
    }

    stopQueueRefresh(){
        if (this.intervalCheckPosition) {
            clearInterval(this.intervalCheckPosition);
            this.intervalCheckPosition = null;
        }
    }
    startQueueRefresh(refresh){
        if (refresh) {
            this.stopQueueRefresh();
            this.noOperatorsStreak = 0;

            this.intervalCheckPosition = setInterval(() => {
                this.checkQueuePosition();
            }, 1000);
        } else {
            this.stopQueueRefresh();
            this.store.commit('setQueuePosition', 0);
        }
    }

    // Reload while queued: the App watcher only fires on status changes, so the
    // persisted "queue" status never restarts the polling by itself.
    resumeQueueRefresh() {
        if (!this.intervalCheckPosition) {
            this.startQueueRefresh(true);
        }
    }

    prevent_ip_banned(threadInfo) {
        if (threadInfo.isBanned) {
            this.stopQueueRefresh();

            this.store.commit('setBanned', {
                banned: threadInfo.isBanned,
                till: threadInfo.till ? new Date(threadInfo.till).toISOString().split('T')[0] : null
            });
            this.store.commit('setLoading', false);

            // Emite el evento que abrirá el diálogo
            EventBus.$emit('openConfirmDialog', {
                callback: (confirmed) => {
                    if (confirmed) {
                        this.store.commit('changeChatWindowStatus', 1);
                        this.store.commit('setBanned', {banned: false, till: null});
                    }
                }
            });
        }
    }


    async checkQueuePosition() {
        const formData = new FormData();
        formData.append('act', 'check_queue_position');
        formData.append('thread', this.store.state.id);
        formData.append('token', this.store.state.token);
        formData.append('lastid', this.store.state.lastId,);
        formData.append('locale', this.store.state.language);
        formData.append('user', true);

        await axios.post(`${this.baseUrl}thread.php?content_type=json&t=${formData.get('act')}`,
            formData
        ).then((response) => {
            this.prevent_ip_banned(response.data)
            this.store.commit('setQueuePosition', response.data.queue_position);
            this.store.commit('setWaitingTime', response.data.waiting_time);

            if( response.data.operators_availables == false ){
                this.noOperatorsStreak = (this.noOperatorsStreak || 0) + 1;
                if (this.noOperatorsStreak >= NO_OPERATORS_POLLS_BEFORE_CLOSE) {
                    this.noOperatorsStreak = 0;
                    this.stopQueueRefresh();
                    this.setThreadClosed();
                    this.store.commit('changeChatWindowStatus', 4);
                }
                return;
            }
            this.noOperatorsStreak = 0;
        });
    }

    checkForOperators(group_id, manageLoading = true) {
        let params = {
            groupid: group_id,
            locale: this.store.state.language
        };

        if (manageLoading) {
            this.store.commit("setLoading", true);

        }

        return axios.get(this.baseUrl + 'operator/operator_list_available.php', { params })
            .then((response) => {
                this.store.commit("setGroupId", params.groupid);
                let operators = response.data.data.operators;
                this.store.commit("setOperators", operators);
                if (operators.length > 0) { this.startOperatorsRefresh(); }
            })
            .catch((error) => {
                // 403 → origin blocked; clears operator list via handleIPError fallback.
                this.handleIPError(error)
            }).finally(() => {
                if (manageLoading) {
                    this.store.commit("setLoading", false);
                }
            });
    }

    async refreshOperators() {
        if (this.store.state.groupId && this.store.getters.chatWindowStatusType === 'waiting_operator') {
            await this.checkForOperators(this.store.state.groupId, false);
        } else {
            this.stopOperatorsRefresh();
        }
    }

    closeThread() {
        var data = {
            act: 'close',
            thread: this.store.state.id,
            token: this.store.state.token,
            lastid: this.store.state.lastId,
            user: true
        };

        if (this.conn) {
            this.conn.close();
        }

        this.stopThreadRefresh();

        if (!this.store.state.id || !this.store.state.token) {
            this.setThreadClosed();
            return Promise.resolve();
        }

        return axios.post(
            this.baseUrl + 'thread.php?content_type=json&t=close',
            qs.stringify(data)
        ).then((response) => {
            var data = response.data;
            if (data.success) {
                this.stopThreadRefresh();
                this.store.commit('setThreadState', "closed");
            }
            else {
                this.startThreadRefresh();
            }
        });

    }

    rateChat(rate_data, partial_save) {

        // old values
        rate_data.opinion = rate_data.solved;
        rate_data.reason = rate_data.experience;

        var action = "survey";
        var data = this.getThreadData(action);

        Object.assign(data, rate_data);

        return axios.post(
            this.baseUrl + 'thread.php?content_type=json&t=' + action,
            qs.stringify(data)
        ).then((response) => {
            if (!partial_save) {
                this.store.commit("chatRated", true);
                changeChatWindowStatus(1);
                this.store.state.config = null;
                return this.store.dispatch('closeCurrentChat', true);
            }
        }).catch((error) => {
            console.error("Error rating chat:", error);
        });
    }

    setThreadClosed() {
        this.store.commit("closeChat");
        if (this.conn) {
            this.conn.close();
        }
    }

    startThreadRefresh() {
        if (this.store.state.id && this.store.state.token) {
            this.checkSocketConnection();
        }

        if (this.threadRefreshCallback) {
            this.stopThreadRefresh();
        }
        this.threadRefreshCallback = setInterval(() => {
            store.http.refreshThread();
        }, 1000);
    }

    startOperatorsRefresh() {
        if (this.store.state.id && this.store.state.token) {
            this.checkSocketConnection();
        }

        if (this.OperatorsfreshCallback) {
            this.stopOperatorsRefresh();
        }

        this.OperatorsfreshCallback = setInterval(() => {
            store.http.refreshOperators();
        }, 1000);

    }

    stopOperatorsRefresh() {
        if (this.OperatorsfreshCallback) {
            clearTimeout(this.OperatorsfreshCallback);
        }
    }

    stopThreadRefresh() {
        if (this.threadRefreshCallback) {
            clearTimeout(this.threadRefreshCallback);
        }
    }

    async getChatGroups(web, group_ids) {
        const data = this.getThreadData('getGroups');
        if (web) {
            data.web = web;
        } else {
            data.group_ids = group_ids;
        }

        try {
            const response = await axios.post(
                `${this.baseUrl}groups.php?content_type=json&t=getGroups`,
                qs.stringify(data)
            );
            // Old backends answer "null" when no group has markets.
            const groups = Array.isArray(response.data) ? response.data : [];
            this.store.commit("setChatTypes", groups);

            const groupsWithCamera = groups.filter(group => group.available_camera).map( group => group.id);

            this.store.commit("setGroupsWithCamera", groupsWithCamera);

        } catch (error) {
            console.error("Error fetching chat groups:", error);
            this.store.commit("setChatTypes", []);
        }
    }

    async verifyChatAvailability() {
        const url = window.location.hostname.replace(/^www\./, '');
        try {
            const response = await axios.post(
                `${this.baseUrl}operator/configurationChat.php?content_type=json&act=getChatAvailability`,
                qs.stringify({ url })
            );

            const availability = response.data;
            this.store.commit("setChatAvailability", availability.chat_available);
            this.store.commit("setVideoChatAvailability", availability.videochat_available);
        } catch (error) {
            console.error("Error fetching chat groups:", error);
            this.store.commit("setChatAvailability", true);
            this.store.commit("setVideoChatAvailability", true);
        }
    }

    getDefaultAnswers(web, group_ids) {
        var data = this.getThreadData();
        if (web) {
            data.web = web;
        } else {
            data.group_ids = group_ids;
        }

        return axios.post(
            this.baseUrl + 'default_responses.php?content_type=json&t=getGroups',
            qs.stringify(data)
        ).then((response) => {
            const responses = response.data.responses;
            const urls = response.data.urls;
            this.store.commit("setDefaultResponses", responses || []);
            this.store.commit("setAppointmentUrls", urls || []);
        }).catch(() => {
            this.store.commit("setDefaultResponses", []);
        });
    }

    sendOfflineMessage(message) {
        var data = this.convertChatMessage(message);
        data.content_type = 'json';
        data.option = 'send-message';
        return axios.post(
            this.baseUrl + 'client.php',
            qs.stringify(data)
        );

    }

    shareUrlWithAgent(url) {
        this.sendRequest('shareUrl', url)
    }

    convertChatMessage(message) {
        let result = {
            'clName': message.name,
            'clLastName': message.lastname,
            'clMail': message.email,
            'clPhone': message.phone,
            'clenquiry': message.subject,
            'clmessage': message.message,
            'clIncidentInteraction': message.interaction,
            'clIncidentMotive': message.motive,
            'clGroupId': message.groupid,
            'referrer': window.location.href
        };
        return result;
    }

    async getIncidentInteractions() {
        await axios.post(
            `${this.baseUrl}incidence_interactions.php?content_type=json&t=getInteractions`,
            qs.stringify({ group_id: this.store.state.groupId, locale: this.store.state.language, act: 'getInteractions' })
        ).then((response) => {
            this.store.commit("setIncidentInteractions", response.data.interactions);
        }).catch(() => {
            this.store.commit("setIncidentInteractions", []);
        });
    }
}

export default ChatService;